import { useState, useEffect, useRef } from 'react';
import fetchAPI from 'app/helpers/fetch';
import { Values, Errors } from './types';

const TIMEOUT = 500;

// eslint-disable-next-line max-lines-per-function
export const useServerValidation = (values: Values, field: keyof Values): [boolean, boolean, Errors, () => void] => {
  const [errors, setErrors] = useState<Errors>({});
  const timerRef = useRef<number>();

  const validate = () => {
    window.clearTimeout(timerRef.current);
    setErrors({});

    const tid = window.setTimeout(() => {
      fetchAPI('/players/quick_sign_up_validation', {
        method: 'POST',
        body: JSON.stringify({ player: { [field]: values[field] } }),
      })
        .then((v) => {
          if (timerRef.current === tid) setErrors(v.errors);
        })
        .catch((err: string) => console.error(err))
        .finally(() => {
          if (timerRef.current === tid) timerRef.current = undefined;
        });
    }, TIMEOUT);
    timerRef.current = tid;
  };

  const isValidating = !!timerRef.current;
  const isValid = !isValidating && !Object.keys(errors).length;

  return [isValid, isValidating, errors, validate];
};

export const useFieldValidation = (values: Values, field: keyof Values): [boolean, boolean, Errors] => {
  const [isValid, isValidating, errors, validate] = useServerValidation(values, field);

  useEffect(validate, [values[field]]);

  return [isValid, isValidating, errors];
};
